import { ContentWrapper, Flex } from '@mprolab/uikit'
import React, { useMemo } from 'react'
import styled from 'styled-components'
import { MarkdownBody } from 'views/Documentation/MarkdownBody'
import { buildHeadingOutline } from 'views/Documentation/headingOutline'
import terms from './terms.md?raw'

/**
 * The Terms of Use, rendered from one markdown source.
 *
 * It reuses the documentation's renderer rather than growing a second one: the
 * two would drift, and of the two this is the one where a table rendering
 * badly costs somebody a fee they did not know they were paying.
 */
const MainWrapper = styled(Flex)`
  flex-direction: column;
  padding: 64px 0;
  max-width: 820px;
`

const TermsConditions: React.FC = () => {
  const outline = useMemo(() => buildHeadingOutline(terms), [])

  return (
    <Flex justifyContent="center">
      <ContentWrapper>
        <MainWrapper mt="82px">
          <MarkdownBody markdown={terms} outline={outline} />
        </MainWrapper>
      </ContentWrapper>
    </Flex>
  )
}

export default TermsConditions
